 var clickHeaders = document.getElementById('footer').querySelectorAll('h5');
 clickHeaders.forEach(function (element, index) {
   element.addEventListener('click', function () {
      element.parentNode.classList.toggle('active');
   });
 });
